import React, { memo, forwardRef } from "react";
const SvgCapitalY = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M17.26 16.94v4.9c0 .307-.047.553-.14.74a1.344 1.344 0 01-.34.42.814.814 0 01-.4.2c-.147.04-.273.06-.38.06-.107 0-.233-.02-.38-.06a.94.94 0 01-.42-.2 1.518 1.518 0 01-.32-.42c-.094-.187-.14-.433-.14-.74v-4.9l-4.56-6.02c-.16-.227-.26-.413-.3-.56a1.477 1.477 0 01-.06-.38c0-.347.12-.64.36-.88s.54-.36.9-.36c.187 0 .38.053.58.16.2.093.413.3.64.62l3.76 5.32 3.78-5.38c.227-.307.433-.5.62-.58.2-.093.38-.14.54-.14.306 0 .58.107.82.32.24.213.36.493.36.84 0 .12-.027.26-.08.42-.04.16-.134.333-.28.52l-4.56 6.1z"
      />
    </svg>
  );
});
SvgCapitalY.displayName = "SvgCapitalY";
const MemoForwardRef = memo(SvgCapitalY);
export default MemoForwardRef;
